import { SiteRateScheduleSaveResult } from '~hooks/useSiteRateSchedule/siteRateScheduleSaveResult';

// On Copy & Edit, the form's `defaultSiteRateScheduleId` is either:
//   - A real server id (the source SRS lives on a shared project that
//     survives the strip), or
//   - A clientKey pointing at a row whose SRS was matched by conditions
//     and recreated fresh on save (completed orders, order-owned SRS).
//
// The order POST defers writing this field; this helper resolves the
// value for the post-SRS PATCH:
//   - Pass `sourceDefaultSrsId` (the form's value at submit) and the
//     SRS save result.
//   - If a matching create lands its `clientKey` against
//     `sourceDefaultSrsId`, return that create's new `serverId`.
//   - Otherwise return `sourceDefaultSrsId` unchanged — it's already a
//     valid server id (project-owned case) or there's no recreation.
export const resolveDefaultSiteRateScheduleId = (
  sourceDefaultSrsId: string | null | undefined,
  saveResult: SiteRateScheduleSaveResult | null,
): string | null => {
  if (!sourceDefaultSrsId) return null;
  const starredCreate = saveResult?.creates.find(
    (c) => c.clientKey === sourceDefaultSrsId && c.serverId,
  );
  return starredCreate?.serverId ?? sourceDefaultSrsId;
};
